/** @jsxImportSource @emotion/react */
import { Card } from "primereact/card";
import { Skeleton } from "primereact/skeleton";

// Esqueleto de una sección de listado mientras cargan los datos, como en el
// admin: título y subtítulo, una card opcional arriba (`cardArriba`, p. ej. los
// totales de Facturación) y la card de la tabla con la barra de búsqueda,
// `filtros` desplegables, el botón de Excel y las filas.
export default function SkeletonListado({ filtros = 1, cardArriba = false, filas = 6 }) {
  return (
    <>
      <div css={{ display: "flex", flexDirection: "column", gap: "0.5em", margin: "2em 0 1em" }}>
        <Skeleton width="14rem" height="2rem" />
        <Skeleton width="22rem" maxWidth="100%" height="1rem" />
      </div>
      {cardArriba && (
        <Card css={{ marginBottom: "1em" }}>
          <Skeleton height="4rem" />
        </Card>
      )}
      <Card css={{ marginBottom: "1em" }}>
        <div css={{ display: "flex", flexWrap: "wrap", justifyContent: "flex-end", gap: "0.5em", marginBottom: "1em" }}>
          <Skeleton width="14rem" height="2.5rem" />
          {[...Array(filtros)].map((_, i) => (
            <Skeleton key={i} width="10rem" height="2.5rem" />
          ))}
          <Skeleton width="2.5rem" height="2.5rem" />
        </div>
        <div css={{ display: "flex", flexDirection: "column", gap: "0.5em" }}>
          {[...Array(filas)].map((_, i) => (
            <Skeleton key={i} height="3rem" />
          ))}
        </div>
      </Card>
    </>
  );
}
